<script setup lang="ts">
import { SelectOption } from "@/models/frontend-only/SelectOption";

const MajorKeys = [
  "Ab",
  "A",
  "Bb",
  "B",
  "C",
  "C#",
  "Db",
  "D",
  "Eb",
  "E",
  "F",
  "F#",
  "Gb",
  "G",
].reverse();

const MinorKeys = [
  "Abm",
  "Am",
  "Bbm",
  "Bm",
  "Cm",
  "C#m",
  "Dm",
  "D#m",
  "Ebm",
  "Em",
  "Fm",
  "F#m",
  "Gm",
  "G#m",
].reverse();

const songStore = useSongStore();
const availableKeys = computed(() => {
  if (songStore.song?.defaultKey) {
    return songStore.defaultKey.slice(-1).toString().toLowerCase() === "m"
      ? MinorKeys
      : MajorKeys;
  } else {
    return MajorKeys;
  }
});

const props = withDefaults(
  defineProps<{
    modelValue?: string;
    defaultKey: string;
    id?: string;
  }>(),
  {
    modelValue: "",
  },
);

const options = computed(() =>
  availableKeys.value.map((k) => {
    return {
      label:
        k.toLowerCase() === props.defaultKey.toLowerCase()
          ? `${k} (Default)`
          : k,
      value: k,
    } as SelectOption;
  }),
);

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const data = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});
</script>

<template>
  <FormSelect
    v-model="data"
    :options="options"
    :label="$t('S.LIT_TransposeKeyTC')"
    :id="id"
    small
    class="hidden xl:block"
  />
  <ToolbarButtonDropdown
    :label="$t('S.LIT_TransposeKeyTC')"
    icon="fa-ccli-transpose-5 fa-kit"
    class="xl:hidden"
  >
    <template #label
      ><span class="text-ccli-blue ms-1 hidden sm:inline">{{
        data
      }}</span></template
    >
    <ToolbarButtonDropdownHeader>{{
      $t("S.LIT_TransposeKeyTC")
    }}</ToolbarButtonDropdownHeader>
    <ToolbarButtonDropdownItem
      v-for="o of options"
      @click="data = o.value"
      :key="o.value"
      >{{ o.label }}</ToolbarButtonDropdownItem
    >
  </ToolbarButtonDropdown>
</template>

<style scoped lang="postcss"></style>
